/*
*   File : about-us.js
*   Author : https://evoqins.com
*   Description : About us
*   Version : 1.0.0
*/

import { useNavigate } from "react-router-dom";
import { Header } from "../../Components/Header";
import { Breadcrumb } from "../../Components/Other";
import { useEffect, useState } from "react";
import { Modal } from "bootstrap";
import { VideoPreviewModal } from "../../Components/Modal";

const OUR_VALUES = [{
    title: "Transparent",
    description: "We provide clear, understandable information. about your investments and our fees, empowering you to make informed decisions."
},
{
    title: "Reliable",
    description: "Our platform is built on robust technology and backed by a dedicated support team, ensuring a smooth and consistent user experience."
},
{
    title: "User-Centric",
    description: "We prioritize your needs and milestones, tailoring our services to your unique financial situation."
},
{
    title: "Secure",
    description: "We employ state-of-the-art security measures to protect your personal and financial information, ensuring your peace of mind."
},
{
    title: "Tailored",
    description: "Your financial journey is unique, and we offer personalized investment solutions to meet your specific milestones."
}]

const MASTERS = [{
    image: require("../../Assets/Images/About-us/ca-neha-agrawal.png"),
    name: "CA Neha Agrawal",
    title: "Founder & CEO",
    started: 2009
},
{
    image: require("../../Assets/Images/About-us/aniket-mane.png"),
    name: "Aniket Mane",
    title: "CMO & Founding Member ",
    started: 2010
},
{
    image: require("../../Assets/Images/About-us/ajay-patwari.png"),
    name: "Ajay Patwari",
    title: "Co Founder & Advisor",
    started:2007
},
{
    image: require("../../Assets/Images/About-us/ca-mahendra-kamath.png"),
    name: "CA Mahendra Kamath",
    title: "Co Founder & Advisor",
    started: 2002
}]

const AboutUs = () => {

    const navigate = useNavigate();
    const [showPreview, setShowPreview] = useState(false);

    useEffect(() => {
        if (showPreview === true) {
            const modal = new Modal(document.getElementById("video-preview"));
            modal.show();
        }
    }, [showPreview]);

    function _handleNavigate() {
        navigate("/");
    }

    function _showPreview(status) {
        setShowPreview(status)
    }

    return (
        <div className="bg-white border-radius-tl-40px border-radius-bl-40px">
            {/* Header */}
            <Header type={2} />

            <div className="row ">
                <div className="col-lg-11 pe-lg-0 padding-144px-bottom">
                    <div className="px-4">
                        <Breadcrumb mainPage="Home"
                            currentPage="About us"
                            handleNavigate={_handleNavigate}
                            type={1} />
                        <div className="border-radius-24px margin-44px-top position-relative cursor-pointer" onClick={() => _showPreview(true)}>
                            <div className="e-banner">
                                <img src={require("../../Assets/Images/About-us/banner.png")} alt="Logo"
                                    draggable={false}
                                    height={"auto"}
                                    className="w-100 e-banner-img d-md-block d-none"
                                />
                                <img src={require("../../Assets/Images/About-us/about_us_video_banner.png")} alt="Logo"
                                    draggable={false}
                                    height={"auto"}
                                    className="w-100 e-banner-img d-md-none d-block"
                                />
                                <img src={require("../../Assets/Images/financial-freedom/play.gif")}
                                    alt="play"
                                    width={84}
                                    className="position-absolute right-10px bottom-0 m-auto "
                                />
                            </div>

                        </div>

                        <h3 className="e-montserrat-semi-bold e-font-28 e-line-height-44 color-rebecca-purple mt-md-5 mt-0 pt-3 margin-20px-bottom">Simple, Personalised, Collaborative.</h3>
                        <p className="e-montserrat-regular e-font-18 e-line-height-30 color-outer-space mb-md-5 mb-2">A perfect trio, that makes Mintlt the most loved Mutual fund management app amongst its users and investors. Our user-friendly platform makes it easy for anyone, from beginners to seasoned investors, to build diversified portfolios, track performance, and access educational resources - all with the goal of making financial growth accessible and empowering. Our intuitive app allows users to explore, invest in, and manage a wide range of funds with ease, offering a seamless and secure experience at their finger-tips.</p>
                        <div className="row d-flex row-gap-32px">
                            <div className="col-md-6">
                                <p className="e-montserrat-semi-bold e-font-28 e-line-height-44 color-rebecca-purple mb-2">Our Vision</p>
                                <p className="e-montserrat-regular e-font-16 e-line-height-26 mb-0">Our goal is to be recognized as the most Trusted Mutual Fund App and Solution Provider, ensuring and encouraging the achievable growth of our clients and investors at large.</p>
                            </div>
                            <div className="col-md-6">
                                <p className="e-montserrat-semi-bold e-font-28 e-line-height-44 color-rebecca-purple mb-2">Our Mission</p>
                                <p className="e-montserrat-regular e-font-16 e-line-height-26 mb-0">Our mission is to empower investors at large to achieve financial well-being and independence through personalized guidance, innovative strategies, and unwavering integrity Also fostering a community of responsible and informed investors committed to achieving financial well-being and driving positive change in the world.</p>
                            </div>
                        </div>

                        <h3 className="e-montserrat-semi-bold e-font-28 e-line-height-44 color-rebecca-purple  mt-md-5 mt-0 pt-3 mb-md-5 mb-2">Our Values</h3>
                        <div className="row d-flex row-gap-64px">

                            {
                                OUR_VALUES.map((item, key) =>
                                    <div className="col-md-4 col-sm-6 " key={key}>
                                        <p className="e-montserrat-medium e-font-20 e-line-height-30 color-dark-jungle-green mb-2">{item.title}</p>
                                        <p className="e-montserrat-regular e-font-16 e-line-height-26 mb-0">{item.description}</p>
                                    </div>
                                )
                            }
                        </div>

                        <h3 className="e-montserrat-semi-bold e-font-28 e-line-height-44 color-rebecca-purple  mt-md-5 mt-0 pt-3 margin-32px-bottom">Meet The Minting Masters</h3>
                        <div className="row margin-64px-bottom d-flex row-gap-32px">
                            {
                                MASTERS.map((item, key) =>
                                    <div className="col-lg-3 col-6 d-flex justify-content-center align-items-center flex-column" key={key}>
                                        <img src={item.image}
                                            alt={item.name}
                                            width={80}
                                            height={80}
                                            draggable={false} />
                                        <p className="e-montserrat-semi-bold e-font-18 e-line-height-28 color-eerie-black margin-20px-top mb-0 text-center">{item.name}</p>
                                        <p className="e-montserrat-regular e-font-16 e-line-height-24 color-rebecca-purple mb-0 text-center">{item.title}</p>
                                        <p className="e-montserrat-medium e-font-16 e-line-height-24 color-rebecca-purple mb-0 text-center">(Exp. {new Date().getFullYear() - item.started} Yrs)</p>
                                    </div>
                                )
                            }
                        </div>
                        <p className="text-center e-montserrat-regular e-font-20 e-line-height-32 color-eerie-black mb-0">Visit <a href="www.mintit.in" className="color-rebecca-purple">www.mintit.in</a> for more details or reach out to the <span
                            class="d-md-inline d-none"><br /></span>helpdesk at <a href="mailto:helpdesk@mintit.in" className="color-rebecca-purple">helpdesk@mintit.in</a></p>

                        <p className="text-center e-montserrat-regular mt-3 e-font-20 e-line-height-32 color-rebecca-purple mb-0"> <a href=" https://mintit.in/front/pdf/AMFI.pdf" className="color-rebecca-purple"><strong>ARN-281018</strong></a>, CIN: <strong>U66300MH2023PTC41108</strong>, <span
                            class="d-md-inline d-none">GST: <strong>27AARCM3657K1ZR</strong></span></p>

                            <p className="text-center e-montserrat-regular mt-3 e-font-20 e-line-height-32 color-rebecca-purple mb-0">AMFI Registered Mutual Fund Distributor</p>
                    </div>
                </div>
            </div>
            {
                showPreview === true &&
                <VideoPreviewModal url="https://mintit-prod-static-assets.s3.ap-south-1.amazonaws.com/videos/why_Mint_It_1809.mp4"
                    size={450}
                    closeModal={() => {
                        _showPreview(false);
                    }} />
            }
        </div>
    )
}

export default AboutUs;